import Vue from 'vue'
import Router from 'vue-router'
import LandingPage from '@/components/LandingPage'
import ProjectList from '@/components/Projects/ProjectList'
import ProjectOverview from '@/components/Projects/ProjectOverview'
import BuildingOverview from '@/components/Projects/BuildingOverview'
import FloorOverview from '@/components/Projects/FloorOverview'
import ZoneOverview from '@/components/Projects/ZoneOverview'
import Logbook from '@/components/Office/Logbook.vue'
import LogbookInt from '@/components/Office/LogbookInt.vue'
import AuthLogin from '@/components/Auth/AuthLogin.vue'
import AuthLogout from '@/components/Auth/AuthLogout'
import AuthRegister from '@/components/Auth/AuthRegister'
import AuthForgot from '@/components/Auth/AuthForgot'
import AuthConfirm from '@/components/Auth/AuthConfirm'
import Accounts from '@/components/Admin/Accounts'
import Help from '@/components/Help'
import AddPhoto from '@/components/Projects/AddPhoto'
import ProjectStatus from '@/components/Office/ProjectStatus'

import store from '@/store/index'
Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/projectlist',
      name: 'ProjectList',
      component: ProjectList
    },
    {
      path: '/projectoverview/:id',
      name: 'ProjectOverview',
      component: ProjectOverview
    },
    {
      path: '/buildingoverview/:projectId/:buildingId',
      name: 'BuildingOverview',
      component: BuildingOverview
    },
    {
      path: '/flooroverview/:projectId/:buildingId/:floorId',
      name: 'FloorOverview',
      component: FloorOverview
    },
    {
      path: '/zoneoverview/:projectId/:buildingId/:zoneId',
      name: 'ZoneOverview',
      component: ZoneOverview
    },
    {
      path: '/logbook',
      name: 'LogBook',
      component: Logbook
    },
    {
      path: '/logbook-int',
      name: 'LogBookInt',
      component: LogbookInt
    },
    {
      path: '/login',
      name: 'AuthLogin',
      component: AuthLogin
    },
    {
      path: '/logout',
      name: 'AuthLogout',
      component: AuthLogout
    },
    {
      path: '/register',
      name: 'AuthRegister',
      component: AuthRegister
    },
    {
      path: '/accounts',
      name: 'Accounts',
      component: Accounts
    },
    {
      path: '/',
      name: 'LandingPage',
      component: LandingPage
    },
    {
      path: '/help',
      name: 'Help',
      component: Help
    },
    {
      path: '/addPhoto',
      name: 'AddPhoto',
      component: AddPhoto
    },
    {
      path: '/projectstatus',
      name: 'ProjectStatus',
      component: ProjectStatus
    },
    {
      path: '/user/resetPassword',
      name: 'ResetPassword',
      component: AuthForgot
    },
    {
      path: '/user/confirmEmail',
      name: 'ConfirmEmail',
      component: AuthConfirm
    }
  ]
})
// TODO: route guards if not logged in
router.beforeResolve((to, from, next) => {
  if (
    to.path === '/' ||
    to.path === '/login' ||
    to.path === '/register' ||
    to.path === '/user/resetPassword' ||
    to.path === '/user/confirmEmail'
  ) {
    next()
  } else {
    const user = store.getters.user
    if (!user) {
      // store.dispatch('tryRefreshLogin').then(res => {
      //   if (res) {
      //     next()
      //   } else {
      //     next('/login')
      //   }
      next('/login')
    } else {
      if (to.path === '/accounts') {
        // if user is not admin block route
        const adminClaim = store.getters.adminClaim
        if (!adminClaim) {
          next('/')
        } else {
          next()
        }
        next()
      }
      next()
    }
  }
})
router.beforeEach((to, from, next) => {
  store.dispatch('updateCrumbs', to)
  next()
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js